// Locale tags of Iron (localization standard: BCP 47). English is the default
// locale (DSH-016); the deviation from the standard's uk-UA default is
// docs/adr/0001-english-default-locale.md. Add a language here, give it an
// address prefix in platform/i18n/paths.ts and a catalog in web/messages.
export const LOCALES = ["en-US", "uk-UA"] as const;

export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "en-US";

export function isLocale(value: unknown): value is Locale {
  return typeof value === "string" && (LOCALES as readonly string[]).includes(value);
}
